/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */

export type LocaleEnum = typeof LocaleEnum[keyof typeof LocaleEnum];


export const LocaleEnum = {
  DE: 'de',
  EN: 'en',
  FR: 'fr',
  NL: 'nl',
} as const;
